const CheckPermission = (permission, permissions) => {
  if (Array.isArray(permissions)) {
    if (typeof permission === "string" || permission instanceof String) {
      return permissions.includes(permission);
    } else if (Array.isArray(permission)) {
      for (const permissionItem of permission) {
        if (permissions.includes(permissionItem)) {
          return true;
        }
      }
    }
  }

  return false;
};

export default CheckPermission;
